import { type FC } from 'react';
import { Button, Group, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { type PayoutTraderRate } from '~/entities/payout';
import { canonicalizeCalculationRule, type UpdateTraderRateRequest } from '../../../../model';
import { transformValues, validateTraderRate } from '../../../../lib/utils';
import { TraderRateFields } from '../../../TraderRateFields';

interface TraderRateFormProps {
    fallbackTraderId: string;
    isLoading?: boolean;
    isRateLoading?: boolean;
    onSubmit: (values: UpdateTraderRateRequest) => void;
    rate?: PayoutTraderRate;
    traderId?: string;
}

export const TraderRateForm: FC<TraderRateFormProps> = ({
    fallbackTraderId,
    isLoading,
    isRateLoading,
    onSubmit,
    rate,
    traderId,
}) => {
    const form = useForm<UpdateTraderRateRequest>({
        initialValues: {
            calculationRule: canonicalizeCalculationRule(rate?.calculationRule),
            commission: {
                value: rate?.commission?.value ?? '',
            },
            traderId: {
                value: traderId ?? fallbackTraderId,
            },
        },
        transformValues,
        validate: validateTraderRate,
    });

    const isPending = isLoading || isRateLoading;

    return (
        <form
            onSubmit={form.onSubmit((values) => {
                onSubmit(values);
                form.resetDirty();
            })}
        >
            <Stack gap='xs'>
                <TraderRateFields
                    commissionInputProps={form.getInputProps('commission.value')}
                    calculationRuleInputProps={form.getInputProps('calculationRule')}
                    disabled={isPending}
                />

                <Group justify='flex-end'>
                    <Button
                        type='submit'
                        disabled={isPending}
                        loading={isPending}
                    >
                        Сохранить
                    </Button>
                </Group>
            </Stack>
        </form>
    );
};
